var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileyHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 137.761,
    height: 137.761
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    stroke: "#8DCDF9",
    strokeWidth: 7.761,
    cx: 68.881,
    cy: 68.881,
    r: 65
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#8DCDF9",
    cx: 68.881,
    cy: 69.851,
    r: 53.358
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.645 54.497a6.803 6.803 0 100-13.606 6.803 6.803 0 000 13.606M82.116 54.497a6.803 6.803 0 100-13.606 6.803 6.803 0 000 13.606M103.67 69.838c0-.755-.412-1.027-4.454-1.027h-.338c-4.45 0-4.586.272-4.586 1.027h-.004c0 14.011-11.397 25.411-25.411 25.411-14.007 0-25.407-11.401-25.407-25.411 0-.755-.412-1.027-4.45-1.027h-.342c-4.45 0-4.586.272-4.586 1.027 0 19.184 15.601 34.793 34.785 34.793s34.793-15.609 34.793-34.793"
  }))));
}
export default SvgSmileyHappy;